const isProduction = import.meta.env.VITE_ENV === 'production'

/** Glows account page on the landing site (external to platform-ui). */
export const GLOWS_ACCOUNT_URL = isProduction
  ? 'https://glows.ai/account'
  : 'https://dev-landing.glows.ai/account'
